var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('FontAwesomeIcon',{staticClass:"mx-1",attrs:{"id":_vm.id,"icon":"question-circle"}}),_c('b-tooltip',{attrs:{"target":_vm.id,"placement":"right"}},[_vm._v(_vm._s(_vm.tooltipText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }